module.exports = __webpack_public_path__ + "static/img/sound-hero@2x.d7ba5bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-mini-guitar/sound-hero@2x.png
// module id = Xb0p
// module chunks = 13